import { router } from "@inertiajs/react"
import { useState } from "react"

const useCreateGame = () => {
  const [processing, setProcessing] = useState(false)

  const createGame = (options?: { chess960?: boolean; start?: string }) => {
    const data: Record<string, string> = {}
    if (options?.chess960) data.chess960 = "true"
    if (options?.start) data.start = options.start

    setProcessing(true)
    router.post("/games", data, {
      async: true,
      onFinish: () => setProcessing(false),
    })
  }

  return {
    createGame,
    processing,
  }
}

export default useCreateGame
